import { SortDescriptor } from '@progress/kendo-data-query';

import { UDViewTagSelectionEnum } from '../../../udView/udview';
import { dashboardFlightFilters } from '../../utils/dashboard';
import { DashboardFlightColumn, DashboardFlightsPanel } from './DashboardFlightsPanel';

const columns: DashboardFlightColumn[] = [
    { id: 'acid', field: 'normalizedAcid', title: 'Aircraft ID', tagSelector: UDViewTagSelectionEnum.Acid },
    { id: 'acType', field: 'aircraftType', title: 'AcType', tagSelector: UDViewTagSelectionEnum.AircraftType },
    { id: 'origin', field: 'origin', title: 'Origin', tagSelector: UDViewTagSelectionEnum.Origin },
    { id: 'destination', field: 'destination', title: 'Dest', tagSelector: UDViewTagSelectionEnum.Destination },
    { id: 'altitude', field: 'altitude', title: 'Altitude', tagSelector: UDViewTagSelectionEnum.Altitude },
    { id: 'etaFAA', field: 'arrivalTime', title: 'ETA', tagSelector: UDViewTagSelectionEnum.EtaFaa }
];
const defaultSort: SortDescriptor[] = [{ field: 'normalizedAcid', dir: 'asc' }];
const EmergencyFlightsList = () => {
    return (
        <DashboardFlightsPanel
            title="Emergency Flights"
            flightFilters={dashboardFlightFilters.emergency}
            columns={columns}
            defaultSort={defaultSort}
            variant="emergency"
            emptyText="No emergency flights"
        />
    );
};

export default EmergencyFlightsList;
